import script from "./ExcludedProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcludedProducts.vue?vue&type=script&setup=true&lang=js"

import "./ExcludedProducts.vue?vue&type=style&index=0&id=2268c0e0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2268c0e0"]])

export default __exports__